import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../service/auth.service";
import { DOCUMENT } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { israelPhoneNumberValidator } from "src/app/validators/israelPhoneNumberValidator";
import { NotificationService } from "../../Data/service/notification.service";
import { AppleDeviceService } from "../../services/apple-device.service";
import { AndroidDeviceService } from "../../services/android-device.service";
import { MustChangePasswordService } from "../../services/must-change-password.service";
import { LanguageService } from "../../shared/services/language.service";
import { HttpConfigInterceptor } from "../../interciptor/jwt.interceptor";
import { Language } from "src/app/landing-pages/thi/thi-translations";
import { normalizeThiLang } from "src/app/landing-pages/thi/thi-lang.util";
const Swal = require('sweetalert2')

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})

export class LoginComponent implements OnInit {
  public show: boolean = false;
  userLanguage:string;
  curentLang:string="";
  landingLang: Language = "ar";
  LoginForm:FormGroup;
  
  constructor(@Inject(DOCUMENT) private document: Document  , 
    private spinner: NgxSpinnerService ,
    private authService:AuthService ,
    private Router:Router,
    private notificationService: NotificationService,
    private route: ActivatedRoute,

    private ToastrService:ToastrService ,
    public translate:TranslateService ,
    private loader: LoadingBarService,
    private appleDeviceService: AppleDeviceService,
    private androidDeviceService: AndroidDeviceService,
    private mustChangePasswordService: MustChangePasswordService,
    private languageService: LanguageService,
   ) 
   { 
    this.curentLang = localStorage.getItem('curentLang')||'ar';
    this.landingLang = normalizeThiLang(this.curentLang);
    this.languageService.apply(this.curentLang, { refreshRoute: false });
    this.LoginForm = new FormGroup({
      phone_number: new FormControl('' ,[Validators.required , israelPhoneNumberValidator(7, 10)]),
      password: new FormControl('' , [Validators.required]),
    });    
 };


 

  submitLoginForm(RegisterForm: FormGroup) {
    if (
      this.LoginForm.value.phone_number == ''||
      this.LoginForm.value.password == ''
       ) 
      {
      Swal.fire({
        icon: 'warning',
        title: this.curentLang === 'ar' ? 'يرجى ملء جميع الحقول' : (this.curentLang === 'en' ? 'Please fill all fields' : (this.curentLang === 'he' ? 'בבקשה תמלא את כל השדות' : ''))
      });
      
      return; 
    }
      
    else
    {
      let customerPhone = this.LoginForm.value.phone_number;
      if (customerPhone.startsWith('0')) {
        customerPhone = customerPhone.substring(1);
      }

      let model = {
        phone_number: '+972' + customerPhone,
        password: this.LoginForm.value.password,
      };
     
      this.spinner.show();
      this.authService.loginOtpRequest(model).subscribe({
        next: (res) => {
          if (res.status === 200) {
            if (res.step === 'OTP_REQUIRED') {
              this.authService.loginOtpContext = {
                phone_number: model.phone_number,
                userId: res.userId
              };
              this.Router.navigate(['/otp'], { queryParams: { mode: 'login-otp' } });
            } else {
              this.applyLoginSuccess(res);
            }
          } else if (res.status === 403) {
            const msg = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
            if (res.code === 'IP_BLOCKED' && res.blockedUntil) {
              const until = this.curentLang === 'ar' ? ` حتى ${new Date(res.blockedUntil).toLocaleString('ar')}` : (this.curentLang === 'he' ? ` עד ${new Date(res.blockedUntil).toLocaleString('he')}` : ` until ${new Date(res.blockedUntil).toLocaleString('en')}`);
              Swal.fire({ icon: 'error', title: msg + until });
            } else {
              Swal.fire({ icon: 'error', title: msg });
            }
          } else if (res.status === 429) {
            const rateMsg = this.curentLang === 'ar' ? 'محاولات كثيرة. انتظر دقيقة ثم حاول مجدداً.' : (this.curentLang === 'he' ? 'יותר מדי ניסיונות. חכה דקה ונסה שוב.' : 'Too many attempts. Please wait a minute and try again.');
            Swal.fire({ icon: 'warning', title: rateMsg });
          } else if (res.status === 400 || res.status === 500) {
            const errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
            Swal.fire({ icon: 'error', title: errorMessage || (this.curentLang === 'ar' ? 'حدث خطأ' : 'An error occurred') });
          }
        },
        error: (err) => {
          const status = err?.status;
          if (status === 429) {
            const rateMsg = this.curentLang === 'ar' ? 'محاولات كثيرة. انتظر دقيقة ثم حاول مجدداً.' : (this.curentLang === 'he' ? 'יותר מדי ניסיונות. חכה דקה ונסה שוב.' : 'Too many attempts. Please wait a minute and try again.');
            Swal.fire({ icon: 'warning', title: rateMsg });
          } else {
            const msg = err?.error?.messageAr || err?.error?.messageEn || err?.error?.messageHe || (this.curentLang === 'ar' ? 'حدث خطأ في الاتصال.' : 'Connection error.');
            Swal.fire({ icon: 'error', title: msg });
          }
        },
        complete: () => this.spinner.hide()
      });
    }

  };

  private applyLoginSuccess(res: any) {
    HttpConfigInterceptor.resetSessionExpiredToastFlag();
    localStorage.setItem('token', res.accessToken);
    if (res.refreshToken) localStorage.setItem('refreshToken', res.refreshToken);
    localStorage.setItem('user_type', res.userData.user_type);
    localStorage.setItem('userType_en', res.userData.userType_en);
    localStorage.setItem('user_id', res.userData.user_id);
    localStorage.setItem('office_id', res.userData.office_id);
    localStorage.setItem('merchant_id', res.userData.merchant_id);
    localStorage.setItem('companyDefault', res.userData.company_default);
    localStorage.setItem('curentLang', res.userData.language);
    this.authService.saveCurrentUser();
    // Silent fire-and-forget: overwrite IP-based location with exact browser coordinates
    this.authService.getBrowserLocation().then((loc) => {
      if (loc) { this.authService.updateSessionLocation(loc.city, loc.country).subscribe({ error: () => {} }); }
    });
    const userId = res.userData.user_id;
    this.notificationService.checkPermissionAndRequest(userId);
    if (res.mustChangePassword === true) {
      this.mustChangePasswordService.setRequired(res.userData?.phone_number);
    }
    if (!res.deviceAlreadyTrusted) {
      const prompt = this.translate.instant('TrustedDevices.addTrustedPrompt');
      const confirmT = this.translate.instant('TrustedDevices.addTrustedConfirm');
      const cancelT = this.translate.instant('TrustedDevices.addTrustedCancel');
      Swal.fire({
        icon: 'question',
        title: prompt,
        showCancelButton: true,
        confirmButtonText: confirmT,
        cancelButtonText: cancelT,
      }).then((result) => {
        this.navigateAfterLogin(res);
        if (result.isConfirmed) {
          this.authService.markCurrentDeviceTrusted().subscribe({ error: () => {} });
        }
      });
    } else {
      this.navigateAfterLogin(res);
    }
  }

  private navigateAfterLogin(res: any) {
    const userType = res.userData.user_type;
    const target =
      userType === 100 || userType === 101
        ? '/dashboard/dashboard'
        : (userType === 300 || userType === 301)
          ? '/dashboard/office-companies'
          : '/dashboard/dashboard';

    this.authService.isLogin.next(true);
    this.Router.navigate([target]).then(() => {
      this.appleDeviceService.recheckBannerVisibility();
      this.androidDeviceService.recheckBannerVisibility();
    });
  }

  changeLanguage(lang:string)
	{ 
	  this.languageService.apply(lang, { refreshRoute: false });
	  this.curentLang = lang;
    this.landingLang = normalizeThiLang(lang);
	};

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      let token = params['token'];
      // If token is not in query params, try to extract from hash fragment
      if (!token && window.location.hash) {
        const hash = window.location.hash;
        const match = hash.match(/[?&]token=([^&]+)/);
        if (match) {
          token = match[1];
        }
      }

      if (token) {
        localStorage.setItem('token', token);
        try {
          await this.authService.saveCurrentUser();
          if (localStorage.getItem('token')) {
            this.authService.isLogin.next(true);
            this.Router.navigate(['/dashboard/dashboard']);
          } else {
            this.displayLoginFormFallback();
          }
        } catch (error) {
          localStorage.removeItem('token');
          this.authService.isLogin.next(false);
          this.displayLoginFormFallback();
        }
        return;
      }

      if (localStorage.getItem('token')) {
        this.authService.isLogin.next(true);
        this.Router.navigate(['/dashboard/dashboard']);
        return;
      }

      this.displayLoginFormFallback();
    });
  }

  private displayLoginFormFallback() {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
  }

  showPassword() {
    this.show = !this.show;
    const passwordInput = document.querySelector('input[name="login[password]"]') as HTMLInputElement;
    if (passwordInput) {
      passwordInput.focus();
    }
    this.handlePasswordValidation(this.LoginForm);
  }

  handlePasswordValidation(formGroup: FormGroup) {
    const passwordControl = formGroup.get('password');
    if (passwordControl) {
      passwordControl.markAsTouched();
    }
  }

}
